import { createContext, useContext } from "react";
//#region src/ui/tooltip/context.tsx
const TooltipContext = createContext(null);
const TooltipContextProvider = TooltipContext.Provider;
/** Returns the current tooltip compound-component context. Throws outside `Tooltip.Root`. */
function useTooltipContext() {
	const ctx = useContext(TooltipContext);
	if (!ctx) throw new Error("Tooltip compound components must be used within a Tooltip.Root");
	return ctx;
}
function useOptionalTooltipContext() {
	return useContext(TooltipContext);
}
//#endregion
export { TooltipContextProvider, useOptionalTooltipContext, useTooltipContext };

//# sourceMappingURL=context.js.map